import React from 'react';
import { MailCheck } from 'lucide-react';

/**
 * Les réponses de la Démarche envoyée au client — toujours affichées telles quelles, indépendamment du
 * modèle de Brief choisi pour le dossier (2026-09-01, demande d'Emeni : le Brief n'a plus besoin d'être la
 * même Démarche que la plaquette, mais ces réponses restent visibles quoi qu'il arrive).
 */
export function ClientDemarcheAnswers({ demarcheName, answers }: {
    demarcheName: string;
    answers: { id: string; question: string; answer: string }[];
}) {
    if (answers.length === 0) return null;

    return (
        <div className="space-y-2 p-3 rounded-xl bg-surface-soft border border-border">
            <p className="text-[11px] font-bold text-content flex items-center gap-1.5">
                <MailCheck size={12} className="text-brand-600 dark:text-brand-400 shrink-0" />
                Réponses du client{demarcheName ? <> — <span className="font-normal text-content-muted">{demarcheName}</span></> : null}
            </p>
            <div className="space-y-2">
                {answers.map((a) => (
                    <div key={a.id}>
                        <p className="text-[11px] font-bold text-content-muted">{a.question}</p>
                        <p className="text-xs text-content whitespace-pre-wrap">{a.answer}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
